import { useCallback } from 'react'
import { rudderClient, trackEvent } from '@configs/rudderstack'

type Props = {
  [key: string]: string | number | boolean | undefined
}

export const useRudderstack = () => {
  const identify = useCallback((id: string | number) => {
    rudderClient.identify(id.toString(), {}, {})
  }, [])

  // onFlush (opcional) avisa quando o evento saiu — obrigatório antes de
  // navegação que descarrega a página (ex.: ida ao checkout).
  const track = useCallback(
    (event: string, properties?: Props, onFlush?: () => void) => {
      trackEvent(event, { ...properties }, onFlush)
    },
    [],
  )
  return {
    track,
    identify,
  }
}
